import * as React from "react";
import { cn } from "../../lib/utils.js";

/**
 * Select primitive — native <select> styled with design tokens.
 * Kept native (not Radix) for mobile accessibility; consumers who need
 * a custom listbox can compose Radix directly.
 */
export const Select = React.forwardRef(
  ({ className, error = false, children, ...props }, ref) => (
    <select
      ref={ref}
      aria-invalid={error || undefined}
      className={cn(
        "flex h-10 w-full rounded-md px-3 py-2 text-sm",
        "bg-surface-1 text-text-primary",
        "border shadow-well transition-colors",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-0",
        // border-strong — mismo criterio que Input (WCAG 1.4.11, 3:1).
        error
          ? "border-danger focus-visible:ring-danger/40"
          : "border-border-strong focus-visible:border-primary focus-visible:ring-primary/40",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = "Select";
